import requestor from "requestor";

import BaseRoute from "utils/base_route";
import TestsContainer from "./containers/tests";

import testSetFetchAction from "modules/flowmaster/actions/testset_fetch";

export default class extends BaseRoute {
  constructor(store) {
    super("llm-tests", store);
  }

  getComponents(location, cb) {
    cb(null, TestsContainer);
  }

  onEnter(state) {
    this.fetchData(state);
  }

  fetchData() {}

  clearActiveData() {}

  fetchTestSets(state) {
    const {organisationId} = state.params;
    this.store.dispatch(testSetFetchAction(requestor)(organisationId));
  }
}
